// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var LSSelections;
(function (LSSelections) {
    LSSelections["ELECTION_EVENT"] = "selected-election-event-id";
    LSSelections["ELECTION"] = "selected-election-id";
    LSSelections["CONTEST"] = "selected-contest-id";
    LSSelections["CANDIDATE"] = "selected-candidate-id";
})(LSSelections || (LSSelections = {}));
